<script setup lang="ts">
import { Card, CardTitle, CardContent } from "@/components/ui/card"
import { Separator } from "@/components/ui/separator"
import { useConfigStore } from "@/stores/config"

const configStore = useConfigStore()
</script>

<template>
  <div class="container flex justify-center">
    <Card
      class="flex items-center justify-center border-pink-200 text-center lg:w-[500px]"
    >
      <FaIcon icon="fat fa-arrows-rotate" class="text-pink h-10 w-10" />
      <CardTitle as="h1" class="text-grey-darken-1">
        {{ $t("general.maintenance.unavailable.title") }}
      </CardTitle>

      <Separator class="bg-grey-lighten-3 w-[180px]!" />

      <CardContent
        class="flex flex-col items-center gap-4 py-0 text-sm md:text-base"
      >
        <p class="text-grey-darken-1 text-center font-sans">
          {{ $t("general.maintenance.unavailable.body_1") }}
        </p>
        <div>
          <p class="text-grey-darken-1 text-center font-sans">
            {{ $t("general.maintenance.unavailable.body_2") }}
          </p>
          <a
            :href="configStore.urls.status_url"
            target="_blank"
            class="text-teal underline underline-offset-4 hover:no-underline"
            :aria-label="$t('general.maintenance.unavailable.body_2')"
          >
            {{ $t("general.maintenance.unavailable.status") }}
          </a>
        </div>
      </CardContent>
    </Card>
  </div>
</template>
